<div class="tier-rate-modal">
  <div class="modal-header">
    <h2 class="modal-title">{{ isEdit ? 'Edit Tier Rate' : 'Add Tier Rate' }}</h2>
    <button
      type="button"
      mat-icon-button
      class="close-btn"
      aria-label="Close"
      (click)="cancel()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()" class="modal-body" novalidate>
    <!-- Tier Model — select of canonical names, with a Custom… toggle that
         swaps in a free-text input for legacy / one-off tier names. -->
    <div class="tier-row">
      <mat-form-field appearance="outline" floatLabel="always" class="form-field tier-field">
        <mat-label>Tier Model</mat-label>
        <ng-container *ngIf="!customTier; else customTierInput">
          <mat-select formControlName="tierModel">
            <mat-option *ngFor="let t of canonicalTiers" [value]="t">{{ t }}</mat-option>
          </mat-select>
        </ng-container>
        <ng-template #customTierInput>
          <input matInput formControlName="tierModel" maxlength="64" placeholder="Custom tier name" />
        </ng-template>
        <mat-error *ngIf="form.controls.tierModel.hasError('required')">Required</mat-error>
      </mat-form-field>

      <a class="link-action" (click)="toggleCustomTier()">
        {{ customTier ? 'Pick from list' : 'Use custom name' }}
      </a>
    </div>

    <!-- Year + Base Rate share a row — both short inputs (4-char year,
         small dollar value) — splitting the row keeps the modal compact
         and the columns proportional to their content length. -->
    <div class="dual-row">
      <mat-form-field appearance="outline" floatLabel="always" class="form-field year-field">
        <mat-label>Year</mat-label>
        <mat-select formControlName="targetYear">
          <mat-option *ngFor="let y of yearOptions" [value]="y">{{ y }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always" class="form-field base-rate-field">
        <mat-label>Base Rate</mat-label>
        <span matTextPrefix>$&nbsp;</span>
        <input matInput type="number" step="0.01" formControlName="baseRate" placeholder="0.00" />
      </mat-form-field>
    </div>
  </form>

  <div class="modal-footer">
    <button
      type="button"
      mat-stroked-button
      class="cancel-btn"
      (click)="cancel()"
    >
      Cancel
    </button>
    <button
      type="button"
      mat-flat-button
      class="primary-btn"
      (click)="submit()"
      [disabled]="form.invalid"
    >
      {{ isEdit ? 'Save' : 'Add' }}
    </button>
  </div>
</div>
